import setBounds from "../../store/utils/set-bounds";
import setPathMatrix from "./set-path-matrix";

/**
 * Get SVG path length
 * @param {Array<SVGGeometryElement>} targets
 * @param {String} _name
 * @param {String} _values
 * @param {String} _property
 * @param {MainClassProps} main
 */
const lengthGet = (targets, _name, _values, _property, main) => {
  for (const target of targets) {
    const SVGParent = target.ownerSVGElement;

    if (SVGParent) {
      if (
        main.dataset.includes("translate-along-path") &&
        !main.SVGOffset.parent
      ) {
        const offset = main.SVGOffset;

        offset.parent = SVGParent;
        offset.path = target;
        offset.matrix = setPathMatrix(SVGParent, main);

        setBounds(main.element, null, 0, null, true);

        main.element.classList.add("tor-hidden");
      }

      return `${target.getTotalLength()}px`;
    }
  }

  return "0px";
};

export default lengthGet;
